// The API can't read GA4's cookies itself (it's on a different domain from
// the app), so we grab client_id/session_id here and send them along in the
// signup request body instead.

function parseDocumentCookies() {
  return document.cookie.split('; ').reduce((acc, pair) => {
    const idx = pair.indexOf('=');
    if (idx === -1) return acc;
    acc[pair.slice(0, idx)] = decodeURIComponent(pair.slice(idx + 1));
    return acc;
  }, {});
}

// GA4's session cookie comes in two formats (old GS1, newer GS2) — handle both.
function parseSessionId(cookieValue) {
  if (cookieValue.startsWith('GS2.')) {
    const firstSegment = cookieValue.split('$')[0]; // "GS2.1.s1734500000"
    const sTimestamp = firstSegment.split('.')[2]; // "s1734500000"
    return sTimestamp ? sTimestamp.slice(1) : undefined;
  }

  if (cookieValue.startsWith('GS1.')) {
    const parts = cookieValue.split('.');
    return parts.length >= 3 ? parts[2] : undefined;
  }

  return undefined;
}

export function isConfigured() {
  return !!process.env.REACT_APP_GA4_MEASUREMENT_ID;
}

export function getGa4Attribution() {
  // No point reading cookies for a property this build isn't wired to send to.
  if (!isConfigured()) return {};

  const cookies = parseDocumentCookies();

  const gaCookie = cookies['_ga'];
  let client_id;
  if (gaCookie) {
    const parts = gaCookie.split('.');
    if (parts.length >= 4) {
      client_id = `${parts[2]}.${parts[3]}`;
    }
  }

  const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
  const sessionCookieName = `_ga_${measurementId.replace(/^G-/, '')}`;
  const sessionCookie = cookies[sessionCookieName];
  const session_id = sessionCookie ? parseSessionId(sessionCookie) : undefined;

  return {
    ...(client_id && { ga_client_id: client_id }),
    ...(session_id && { ga_session_id: session_id }),
  };
}
